import { Capacitor } from '@capacitor/core'

export const ONBOARDING_SEEN_KEY = 'mastermind-onboarding-seen'

export const hasSeenOnboarding = () => {
  try {
    return localStorage.getItem(ONBOARDING_SEEN_KEY) === '1'
  } catch {
    return true
  }
}

export const markOnboardingSeen = () => {
  try {
    localStorage.setItem(ONBOARDING_SEEN_KEY, '1')
  } catch {
    // ignore storage failures
  }
}

/** Native cold start without a restored session should show welcome once. */
export const shouldShowNativeOnboarding = () =>
  Capacitor.isNativePlatform() && !hasSeenOnboarding()
